/* src/app/components/shared/sidebar/sidebar.component.scss */
.side-list-title {
  font-size: 18px;
}
.side-list-child {
  font-size: 16px;
  line-height: 37px;
}
svg {
  height: 20px;
  width: 26px;
}
.text-gray {
  color: var(--theme-selected-state) !important;
}
.rotate {
  transition: transform 0.5s;
  transform: rotate(180deg);
}
.rotate-reverse {
  transition: transform 0.5s;
  transform: rotate(0deg);
}
a.outside-link {
  color: rgba(0, 0, 0, 0.8705882353);
}
/*# sourceMappingURL=sidebar.component.css.map */
